export enum AdExtensionType {
  SiteLink = 'SiteLink',
  Phone = 'Phone',
  Local = 'Local',
  Location = 'Location',
  Call = 'Call',
  MeteredCall = 'MeteredCall',
  MerchantRatings = 'MerchantRatings'
}
